var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTokLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1449_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.8005C19.4363 10.8054 17.4233 10.1618 15.7452 8.96063V17.3381C15.7446 18.8897 15.2703 20.4042 14.3858 21.679C13.5013 22.9538 12.2487 23.9281 10.7954 24.4718C9.34221 25.0155 7.75762 25.1025 6.25358 24.7213C4.74954 24.3401 3.39772 23.5088 2.37889 22.3385C1.36006 21.1683 0.72278 19.7149 0.552262 18.1727C0.381745 16.6305 0.686117 15.073 1.42468 13.7084C2.16325 12.3439 3.3008 11.2373 4.68523 10.5367C6.06966 9.83615 7.63498 9.57492 9.17189 9.78797V14.0016C8.4686 13.7803 7.71339 13.787 7.01411 14.0206C6.31483 14.2542 5.70725 14.7028 5.27812 15.3023C4.84899 15.9018 4.62027 16.6216 4.62461 17.3588C4.62895 18.0961 4.86614 18.8131 5.3023 19.4075C5.73846 20.0019 6.35129 20.4433 7.05327 20.6686C7.75525 20.894 8.51049 20.8917 9.21112 20.6623C9.91176 20.4328 10.522 19.9878 10.9546 19.3908C11.3872 18.7938 11.6202 18.0754 11.6202 17.3381V0.960938H15.7452C15.7423 1.30928 15.7715 1.65716 15.8324 2.00016C15.9757 2.76585 16.2737 3.49425 16.7082 4.14081C17.1427 4.78737 17.7046 5.33849 18.3594 5.76047C19.291 6.37645 20.3832 6.70477 21.5 6.70453V10.8005Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_2082"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.960938H21.5V24.9609H0.5V0.960938Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokLogo);
export default __webpack_public_path__ + "static/media/TikTok-logo.9730aa25e1ef3b7b467a21eaef2b4dea.svg";
export { ForwardRef as ReactComponent };